import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-5366d974"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 2,
  style: {"margin-top":"63vh"}
}
const _hoisted_2 = {
  key: 10,
  class: "spacer"
}
const _hoisted_3 = {
  key: 11,
  class: "spacer"
}
const _hoisted_4 = {
  key: 12,
  class: "spacer"
}
const _hoisted_5 = {
  key: 13,
  class: "spacer"
}
const _hoisted_6 = {
  key: 14,
  class: "spacer"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Empieza algo nuevo", -1))
const _hoisted_8 = {
  key: 15,
  class: "fixed_btn"
}

import InformationTop from '@/components/layouts/InformationTop.vue'
import main from '@/data/main.js'
import DefaultLayout from '@/layouts/DefaultLayout.vue'
import MyRoutes from '@/components/sections/MyRoutes.vue'
import MyCourses from '@/components/sections/MyCourses.vue'
import FavLessons from '@/components/sections/FavLessons.vue'
import LaterLessons from '@/components/sections/LaterLessons.vue'
import StartHere from '@/components/sections/StartHere.vue'
import WelcomeMessage from '@/components/sections/WelcomeMessage.vue'
import { useAuth } from '@/store/useAuth'
import ProdevBanner from '@/components/layouts/ProdevBanner.vue';
import BannerTop from '@/components/layouts/BannerTop.vue'
import RoadMapBar from '@/components/layouts/RoadMapBar.vue'
//import AgendaRight from '@/components/layouts/AgendaRight.vue'
//import AdvertisementMain from '@/components/advertisement/AdevertisementMain.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const store = useAuth()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DefaultLayout, null, {
    default: _withCtx(() => [
      (_unref(main).has_module_banner_prodev)
        ? (_openBlock(), _createBlock(ProdevBanner, { key: 0 }))
        : _createCommentVNode("", true),
      (_unref(main).has_module_roadmap_bar)
        ? (_openBlock(), _createBlock(RoadMapBar, { key: 1 }))
        : _createCommentVNode("", true),
      (_unref(main).has_module_banner_prodev || _unref(main).has_module_roadmap_bar)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1))
        : _createCommentVNode("", true),
      (_unref(store).token)
        ? (_openBlock(), _createBlock(WelcomeMessage, { key: 3 }))
        : _createCommentVNode("", true),
      (_unref(store).token && _unref(main).has_module_banner)
        ? (_openBlock(), _createBlock(InformationTop, { key: 4 }))
        : _createCommentVNode("", true),
      (_unref(main).has_social_network_advice)
        ? (_openBlock(), _createBlock(BannerTop, { key: 5 }))
        : _createCommentVNode("", true),
      (_unref(store).token && _unref(main).has_module_my_routes)
        ? (_openBlock(), _createBlock(MyRoutes, { key: 6 }))
        : _createCommentVNode("", true),
      (_unref(store).token)
        ? (_openBlock(), _createBlock(MyCourses, { key: 7 }))
        : _createCommentVNode("", true),
      (_unref(store).token)
        ? (_openBlock(), _createBlock(LaterLessons, { key: 8 }))
        : _createCommentVNode("", true),
      (_unref(store).token)
        ? (_openBlock(), _createBlock(FavLessons, { key: 9 }))
        : _createCommentVNode("", true),
      (!_unref(store).token)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2))
        : _createCommentVNode("", true),
      (!_unref(store).token)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3))
        : _createCommentVNode("", true),
      (!_unref(store).token)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4))
        : _createCommentVNode("", true),
      (!_unref(store).token)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5))
        : _createCommentVNode("", true),
      (!_unref(store).token)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6))
        : _createCommentVNode("", true),
      _hoisted_7,
      _createVNode(StartHere),
      (_unref(main).has_module_agenda)
        ? (_openBlock(), _createElementBlock("button", _hoisted_8, [
            _createElementVNode("a", {
              href: "https://avemariamalaga.netlify.app/acceso",
              style: _normalizeStyle({backgroundColor: _unref(main).SECONDARY_COLOR}),
              class: "fixed_btn",
              target: "_blank"
            }, "Notificaciones Familias", 4)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})